import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Add-Square--Streamline-Flex"
    >
        <desc>{'Add Square Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="add-square--square-remove-cross-buttons-add-plus-button-+-mathematics-math">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.959867 10.2878C1.114 11.737 2.2727 12.9026 3.71266 13.064c2.21179 0.248 4.36288 0.248 6.57464 0 1.44 -0.1614 2.5987 -1.327 2.7528 -2.7762 0.1138 -1.06976 0.2099 -2.16807 0.2099 -3.2878 0 -1.11973 -0.0961 -2.21805 -0.2099 -3.28784C12.886 2.263 11.7273 1.09745 10.2873 0.935995c-2.21176 -0.247993 -4.36285 -0.247993 -6.57464 0C2.2727 1.09745 1.114 2.263 0.959867 3.71216 0.846083 4.78195 0.75 5.88027 0.75 7c0 1.11973 0.096084 2.21804 0.209867 3.2878Z"
                strokeWidth={1}
            />
            <g id="Group 5615">
                <path
                    id="Vector 1179"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 4v6"
                    strokeWidth={1}
                />
                <path
                    id="Vector 1180"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10 7 4 7"
                    strokeWidth={1}
                />
            </g>
        </g>
    </svg>,
);
